module.exports = __webpack_public_path__ + "img/exo-ape-tablet_a9aed2fe846539bceb2becbca3976ded.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/exo-ape-tablet.jpg
// module id = 295
// module chunks = 0